<template>
    <div class="home_page" :style="{ paddingTop: dataSet.isShowingPWA ? '100px' : '50px' }">
        <div v-for="(item, index) in dataSet.componentList" :key="index">
            <MainHeader @intallPWA="installApp" @isClosedPWA="isClosedPWA" :listGameData="dataSet.groupList"
                @openSidebar="openSidebar" @showPWA="setShowPWA" v-if="isComponentVisible(item, 'header')"
                :itemData="item" @openContactPopup="openContactPopup" @goToDeposit="goToDeposit" />
            <CarousalCard v-if="isComponentVisible(item, 'banners')" :itemData="item" />
            <BannerCard v-if="isComponentVisible(item, 'notice')" :itemData="item" />
            <NoticeBar v-if="isComponentVisible(item, 'newsBar')" :itemData="item" />
            <div v-if="isComponentVisible(item, 'gameGroups')">
                <GroupList :ref="el => setGroupListRef(el)" :listData="dataSet.groupList" @showGameList="showGameList"
                    :itemData="item" />
                <div class="home_game_panel" v-for="(subitem, index) in dataSet.groupList" :key="index">
                    <GamePanel v-if="!showGroupGames" :groupImage="subitem.customIcon" :groupName="subitem.name"
                        :gameList="subitem.games" :itemData="item" @showGames="showGames(subitem)" :itemIndex="index" />
                </div>
            </div>
            <FooterText v-if="isComponentVisible(item, 'footerText')" :itemData="item"
                @openContactPopup="openContactPopup" />
            <MainFooter v-if="isComponentVisible(item, 'footer')" @goToProfile="openProfilePopup" :itemData="item"
                @profileClose="closeProfilePoup" :ref="setFooterRef" @openPWA="openPWAPopup" @reopenBackgroundRechargePopup="reopenBackgroundRechargePopup" />
        </div>
    </div>

    <FloatButton @openAgentPopup="goToAgent" @openPWA="openPWAPopup" />
    <!-- Popup -->
    <SideNavbar ref="sideNavbarRef" :listGameData="dataSet.groupList" @intallPWA="installApp"
        @openContactPopup="openContactPopup" />
    <GamePopup ref="gamePopupRef" @resetSelectedGroup="resetSelectedGroup" @goToProfile="openProfilePopup" />
    <ProfilePopup ref="profilePopupRef" @openAgentPopup="goToAgent" />
    <PromotionPopup ref="promotionRef" @openAgentPopup="goToAgent" @openPWA="openPWAPopup" />
    <PwaAntiBlockingPopup ref="pwaPopupRef" />
    <PwaStatusPopup ref="pwaPopupStatusRef" />
    <ContactServicePopup ref="contactRef" />
    <ClaimListPopup
        v-if="showPop && userStore.allActivityBonusPopup && userStore.claimActivityList.length > 0 && !userStore.pwaShowing && userStore.isInHome"
        ref="claimListPopupRef" @handleShowTreasurePopup="handleShowTreasurePopup" />
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits, defineExpose, onMounted } from 'vue'
import BannerCard from './components/bannerCard.vue'
import CarousalCard from './components/carousalCard.vue'
import NoticeBar from './components/noticeBar.vue'
import GroupList from './components/groupList.vue'
import GamePanel from './components/gamePanel.vue'
import FooterText from './components/footerText.vue'
import PromotionPopup from '@/view/promotion/promotionPopup.vue'
import FloatButton from './components/floatButton.vue'
import { HomeData } from '@/view/home/supportScript'
import MainHeader from '../components/common/mainHeader.vue'
import MainFooter from '../components/common/mainFooter.vue'
import GamePopup from '@/view/game/gamePopup.vue'
import ProfilePopup from '@/view/profile/profilePopup.vue'
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import SideNavbar from '../components/sideNav/sideNavbar.vue'
import { playClickSound } from '@/utils/media'
import ClaimListPopup from '../components/common/claimListPopup.vue'
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const gamePopupRef = ref()
const profilePopupRef = ref()
const promotionRef = ref();
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const contactRef = ref()
const showGroupGames = ref(false)
const groupListRef = ref()
const sideNavbarRef = ref()
const showPop = ref()
const props = defineProps<{
    dataSet: HomeData
}>()

const emits = defineEmits(['setFooterRef', 'goToGamePannel', 'openProfilePopup', 'isComponentVisible', 'installApp', 'isClosedPWA', 'setShowPWA', 'openPWAPopup', 'setGroupListRef', 'resetSelectedGroup', 'goToAgent', 'goToDeposit', 'handleShowTreasurePopup', 'reopenBackgroundRechargePopup'])

const setFooterRef = (el: any) => {
    emits('setFooterRef', el)
};
const showGames = (item: any) => {
    groupListRef.value.setActiopFunGroup(item)
}

const openProfilePopup = () => {
    emits('openProfilePopup')
}

const closeProfilePoup = () => {
    profilePopupRef.value.close()
}
const goToAgent = () => {
    emits('goToAgent')
}

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup',path)
}
const showGameList = (value: any) => {
    showGroupGames.value = value
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};

const installApp = async () => {
    emits('installApp')
}
const isClosedPWA = async (value: any) => {
    emits('isClosedPWA', value)
}
const setShowPWA = async (value: any) => {
    emits('setShowPWA', value)
}

const openPWAPopup = () => {
    emits('openPWAPopup')
}

const setGroupListRef = (el: any) => {
    emits('setGroupListRef', el)
    groupListRef.value = el
}
const resetSelectedGroup = () => {
    emits('resetSelectedGroup')
}

const gamePoupOpen = (id: number) => {
    gamePopupRef.value.open(id);
}

const profilePoupOpen = (list: any) => {
    profilePopupRef.value.open(list);
}

const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}

const openContactPopup = () => {
    contactRef.value.open()
}

const goToDeposit = () => {
    emits('goToDeposit')
}

const openSidebar = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return false; }
    playClickSound()
    sideNavbarRef.value.openSidebar()
}

const reopenBackgroundRechargePopup = () => {
    emits('reopenBackgroundRechargePopup')
}

onMounted(() =>{
    showPop.value = false
    setTimeout(()=>{
        showPop.value = true
    },2000)
})
defineExpose({
    gamePoupOpen,
    profilePoupOpen,
    pwaStatusPoupOpen,
    pwaPoupOpen
})

</script>
<style scoped>
.home_page {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 10px 0;
}

.home_page::-webkit-scrollbar {
    display: none;
}
</style>